module.exports = "https://www.gc-qa.gnp.com.mx/6b5bccfac13db0e4b37716e786436d83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-asegurados-gm.svg
// module id = 8119
// module chunks = 0